import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { container } from 'tsyringe';

import { ConcurrencyStore } from '../../../concurrency/concurrency-store';
import { SubpageStore } from '../subpage-store';

export class DeviceSubpageStore extends SubpageStore {
  subtype: UIDAPresentationTypeEnum.devices = UIDAPresentationTypeEnum.devices;

  private concurrencyStore: ConcurrencyStore;

  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(props, categoryTree, children);

    this.concurrencyStore = container.resolve(ConcurrencyStore);
    this.concurrencyStore.subpageProperty = this.subpageProperty;
  }
}
